import { render, staticRenderFns } from "./ttshop_user.vue?vue&type=template&id=0880e634&scoped=true&"
import script from "./ttshop_user.vue?vue&type=script&lang=js&"
export * from "./ttshop_user.vue?vue&type=script&lang=js&"
import style0 from "./ttshop_user.vue?vue&type=style&index=0&id=0880e634&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0880e634",
  null
  
)

export default component.exports